import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { isMobile } from "react-device-detect";

import { validateEmail } from "../../../middleware/common-functions";
import { Referral } from "../../../models/referers";
import { ErrorType } from "../../../models/errors";
import { IconJumbotron } from "../../common/icons";
import { SENDREFERERS } from "./queries";
import { ReferCard } from "./components";

const ReferFriend = () => {
  const [sendRefererMutation, { loading, called }] = useMutation(SENDREFERERS);
  const [referers, setReferers] = useState<Referral[]>([
    { name: "", email: "" },
  ]);
  const [message, setMessage] = useState("");
  const [error, setError] = useState<ErrorType | false>(false);

  const sendReferer = () => {
    setError(false);
    const filtered = referers.filter((r) => r.name.length > 0);
    if (filtered.length === 0) {
      setError({
        message: "Please add at least one friends' email and their names",
      });
      return;
    }
    let valid = true;
    //validate emails
    filtered.forEach((r) => {
      if (validateEmail(r.email) === false) {
        setError({
          message: `Please add a valid email address for ${r.name}`,
        });
        valid = false;
        return;
      }
    });
    if (!valid) return;
    sendRefererMutation({ variables: { referrals: filtered, message } });
  };

  const addReferer = () => {
    const set_referers = [...referers];
    set_referers.push({ name: "", email: "" });
    setReferers(set_referers);
  };

  const handleType = (ev: { target: HTMLInputElement }) => {
    const value = ev.target.value;
    const type = ev.target.dataset.type as keyof Referral;
    const index = ev.target.dataset.index;
    if (!index) return;
    const set_referers = [...referers];
    set_referers[parseInt(index)][type] = value;
    setReferers(set_referers);
  };

  const handleMessage = (ev: { target: HTMLTextAreaElement }) => {
    const value = ev.target.value;
    setMessage(value);
  };
  return (
    <main className={`${isMobile ? "" : "first-container"} last-container`}>
      <Hero />
      <div className="container">
        <div className="row">
          <div className="col-md-6 py-4">
            <h4>Here's how it works:</h4>
            <p>
              Type in the information here. We will send your colleague an email
              on your behalf telling them to try Flangoo for free. If your
              colleague purchases at least a one-year subscription, you’ll get a
              $10 Teacher's Discovery eGift Card as our way of saying thank you
              for the referral. Only one $10 referral per school.
            </p>
            <p>Who are you going to invite? </p>
          </div>
          <div className="col-md-6">
            {called ? (
              <div className="material_shadows_3 friends_emails">
                <IconJumbotron
                  icon="fad fa-check-double text-success"
                  txt="Referral email sent!"
                  txt_classes="text-dark mt-2"
                  help_text="We'll let you know when your friends make a purchase"
                  help_txt_classes="text-dark mt-2"
                  cta={{ txt: "Go Home", link: "/" }}
                />
              </div>
            ) : (
              <ReferCard
                sendReferer={sendReferer}
                handleType={handleType}
                referers={referers}
                addReferer={addReferer}
                loading={loading}
                message={message}
                handleMessage={handleMessage}
                error={error}
              />
            )}
          </div>
        </div>
      </div>
    </main>
  );
};

const Hero = () => (
  <div
    className="cover_img"
    style={{
      backgroundImage: isMobile
        ? "none"
        : `url(https://flangoo-cdn.s3.us-east-2.amazonaws.com/refer_a_friend_10.jpg?v=3)`,
    }}
  >
    {isMobile ? (
      <img
        src="https://flangoo-cdn.s3.us-east-2.amazonaws.com/refer_a_friend_10.jpg?v=3"
        className="img-fluid"
        alt="Refer a friend"
      />
    ) : null}
    <div className="text_container">
      <div className="container"></div>
    </div>
  </div>
);
export default ReferFriend;
